import React from 'react';
import { WithWebHeaderProps } from '@24i/nxg-sdk-smartott/src/navigation/components/withWebHeader/types';
import View from './View/index.web';
import { ModularSubscriptionsElements } from '../../../../context/SubscriptionsHandlerProvider/types';
import { useViewModel } from './viewModel/index.web';
import withErrorModal, { WithErrorModalProps } from '../../../GenericModal/hoc/ErrorModal';

export const StripePurchase: ModularSubscriptionsElements['PaymentMethodScreen'] = {
    Main: withErrorModal((props: WithWebHeaderProps & WithErrorModalProps) => {
        const viewModelProps = useViewModel(props);
        return <View {...viewModelProps} />;
    }),
    View,
};
